import { OfferType } from "@afidium/ts-facade/model/offerType";
import { DifferenceType } from "@afidium/ts-facade/model/differenceType";
import { PriceEnvelopeInBookingType } from "@afidium/ts-facade/model/priceEnvelopeInBookingType";

export enum FareMethodType {
    Update = 'Update',
    Duplication = 'Duplication'
}

export enum FareActionType {
    Split = 'SPLIT',
    Rebook = 'REBOOK'
}

interface IFareOptimisationRow {
    optimisationOffersWithDifferences: Array<{
        offer: OfferType,
        differenceArray: DifferenceType[]
    }>;
    bookingPrice: PriceEnvelopeInBookingType;
}
